import { cn } from "@/lib/utils"
import { Badge } from "@/components/ui/badge"
import { STATUS_LABELS, type FeedbackContext, type FeedbackStatus } from "@/modules/feedback/lib/shared/types"

export const PLATFORM_LABELS: Record<FeedbackContext["platform"], string> = { desktop: "Компьютер", mobile: "Мобильный браузер", app: "Приложение Casper" }

export const STATUS_STYLE: Record<FeedbackStatus, { dot: string; badge: string }> = {
  new: { dot: "bg-sky-500", badge: "bg-sky-50 text-sky-700" },
  in_progress: { dot: "bg-amber-500", badge: "bg-amber-50 text-amber-800" },
  resolved: { dot: "bg-emerald-500", badge: "bg-emerald-50 text-emerald-700" },
  rejected: { dot: "bg-slate-400", badge: "bg-slate-100 text-slate-600" },
}

export function StatusBadge({ status, className }: { status: FeedbackStatus; className?: string }) {
  return (
    <Badge variant="secondary" className={cn(STATUS_STYLE[status].badge, className)} data-status={status}>
      {STATUS_LABELS[status]}
    </Badge>
  )
}

export function plural(n: number, one: string, few: string, many: string) {
  const m10 = n % 10
  const m100 = n % 100
  if (m10 === 1 && m100 !== 11) return one
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few
  return many
}

/** Где был открыт копилот, по области событий чата и странице */
export function scopeLabel(scope: string | null | undefined, path: string): string {
  if (scope === "mobile-copilot") return "Мобильная вкладка «Копилот»"
  if (scope) return scope
  if (path.startsWith("/copilot")) return "Страница копилота"
  if (path.includes("/scenarios/")) return "Панель копилота в процедуре"
  return path || "—"
}
